import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
    ClickAwayListener,
    Breadcrumbs,
    Divider,
    Grow,
    Grid,
    IconButton,
    Hidden,
    Link,
    ListItemIcon,
    MenuItem, MenuList,
    Paper,
    Popper,
    Tooltip,
    Typography
} from '@material-ui/core';
import {
    ArrowDropDown,
    ArrowLeft,
    ArrowBack,
    Edit
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    title: {
        display: 'none',
        [theme.breakpoints.up('xs')]: {
            display: 'block',
        },
    },
    title_small: {
        display: 'none',
        [theme.breakpoints.up('xs')]: {
            display: 'block',
            maxWidth: 240
        },
    },
}));

// Tlm Breadcrumb component for showing the breadcrumb navigation
export default function TlmBreadcrumbs({ orgInfo, branchInfo, site, tank }) {
    const { t, i18n } = useTranslation();
    let baseUrl = '/orgs/' + orgInfo.orgName + '/branches/';
    const classes = useStyles();
    const [branchesOpen, setBranchesOpen] = React.useState(false);
    const [branchesAnchor, setBranchesAnchor] = React.useState(null);

    const handleBranchesOpen = (event) => {
        setBranchesAnchor(event.currentTarget);
        setBranchesOpen(true);
    };

    const handleBranchesClose = () => {
        setBranchesOpen(false);
    };

    return (
        <React.Fragment>
            {branchInfo === undefined
                ? <IconButton edge='start'
                    aria-haspopup='false'
                    color='primary'
                    component={RouterLink}
                    to={baseUrl.concat(branchInfo.branchName)}>
                    <ArrowLeft />
                </IconButton>
                : <React.Fragment>
                    {site !== null && <Tooltip title={tank !== null ? site : branchInfo.branchName}>
                        <IconButton color='inherit'
                            disabled={site === null ? true : false}
                            component={RouterLink}
                            to={tank !== null ? '/orgs/' + orgInfo.orgName + '/branches/' + branchInfo.branchName + '/sites/' + site :
                                '/orgs/' + orgInfo.orgName + '/branches/' + branchInfo.branchName}
                        >
                            <ArrowBack />
                        </IconButton>
                    </Tooltip>}
                    <Popper style={{ zIndex: 50 }} open={branchesOpen}
                        anchorEl={branchesAnchor}
                        placement='bottom-start'
                        transition>
                        {({ TransitionProps, placement }) => (
                            <Grow {...TransitionProps}
                                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                                <Paper>
                                    <ClickAwayListener onClickAway={handleBranchesClose}>
                                        <MenuList autoFocusItem={branchesOpen} id='profile-list-grow'>
                                            {branchInfo.isBranchEditor && <Divider />}
                                            {branchInfo.branchList.map((name, index) =>
                                                <MenuItem key={index} component={RouterLink}
                                                    to={baseUrl.concat(name)}
                                                    onClick={handleBranchesClose}>
                                                    {name}
                                                </MenuItem>)}
                                            {branchInfo.isBranchEditor && <Divider />}
                                            {branchInfo.isBranchEditor && <MenuItem
                                                component={RouterLink}
                                                to={'/orgs/' + orgInfo.orgName + '/branches/' + branchInfo.branchName + '/edit'}>
                                                <ListItemIcon style={{ minWidth: '30px' }}>
                                                    <Edit />
                                                </ListItemIcon>
                                                {branchInfo.branchName}
                                            </MenuItem>}
                                            {orgInfo.isOrgEditor && <MenuItem
                                                component={RouterLink}
                                                to={baseUrl}
                                                onClick={handleBranchesClose}>
                                                {t("createNewBranch")}
                                            </MenuItem>}
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </React.Fragment>}
            <Breadcrumbs>
                {branchInfo.branchName !== null
                    ? site !== null
                        ? <Grid container item alignItems="center">
                            {false && <Link variant='h5'
                                color='inherit'
                                component={RouterLink}
                                to={baseUrl.concat(branchInfo.branchName)}>
                                {branchInfo.branchName}
                            </Link>}
                            <Hidden smDown>
                                <Tooltip title={t("selectBranch")}>
                                    <IconButton aria-controls={branchesOpen ? 'branches-list-grow' : undefined}
                                        edge='start'
                                        aria-haspopup='true'
                                        onClick={handleBranchesOpen}
                                        color='inherit'>
                                        <Typography className={classes.title} variant='h5' color='inherit' noWrap>
                                            {branchInfo.branchName}
                                        </Typography>
                                        <ArrowDropDown />
                                    </IconButton>
                                </Tooltip>
                            </Hidden>
                            <Hidden mdUp>
                                <Tooltip title={t("selectBranch")}>
                                    <IconButton aria-controls={branchesOpen ? 'branches-list-grow' : undefined}
                                        edge='start'
                                        aria-haspopup='true'
                                        onClick={handleBranchesOpen}
                                        color='inherit'>
                                        <Typography className={classes.title_small} variant='h5' color='inherit' noWrap>
                                            {branchInfo.branchName}
                                        </Typography>
                                        <ArrowDropDown />
                                    </IconButton>
                                </Tooltip>
                            </Hidden>
                        </Grid>
                        : <Grid container item alignItems="center">
                            <Hidden xsDown>
                                <Tooltip title={t("selectBranch")}>
                                    <IconButton aria-controls={branchesOpen ? 'branches-list-grow' : undefined}
                                        edge='start'
                                        aria-haspopup='true'
                                        onClick={handleBranchesOpen}
                                        color='primary'>
                                        <Typography className={classes.title}
                                            variant='h5'
                                            color='inherit'>
                                            {branchInfo.branchName}
                                        </Typography>
                                        <ArrowDropDown />
                                    </IconButton>
                                </Tooltip>
                            </Hidden>
                            <Hidden smUp>
                                <Tooltip title={t("selectBranch")}>
                                    <IconButton aria-controls={branchesOpen ? 'branches-list-grow' : undefined}
                                        edge='start'
                                        aria-haspopup='true'
                                        onClick={handleBranchesOpen}
                                        color='primary'>
                                        <Typography className={classes.title_small} noWrap
                                            variant='h5'
                                            color='inherit'>
                                            {branchInfo.branchName}
                                        </Typography>
                                        <ArrowDropDown />
                                    </IconButton>
                                </Tooltip>
                            </Hidden>
                        </Grid>
                    : site !== null
                        ? <Link variant='h5'
                            color='inherit'
                            component={RouterLink}
                            to={baseUrl.concat('Sites')}>
                            {t("sites")}
                        </Link>
                        : <Typography variant='h5'
                            color='textPrimary'>
                            {t("sites")}
                        </Typography>}
                {site !== null
                    ? tank !== null
                        ? <Link variant='h5'
                            color="inherit"
                            component={RouterLink}
                            to={baseUrl.concat(branchInfo.branchName).concat('/sites/').concat(site)}>
                            {site}
                        </Link>
                        : <Typography variant='h5'
                            color='textPrimary'>
                            {site}
                        </Typography>
                    : null}
                {site !== null && tank !== null
                    ? <Typography variant='h5'
                        color='textPrimary'>
                        {tank}
                    </Typography>
                    : null}
            </Breadcrumbs>
        </React.Fragment>
    );
}
